import styled from 'styled-components';

export const TitleWrap = styled.div`
  display: inline-grid;
  grid-column-gap: 1em;
  grid-template-columns: auto max-content;
  align-items: center;
`;
